import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TextSection extends Component {
  render() {
    return (
      <div className="properties-condition mrg-btm-40 ">
        <h5 className="heading">{this.props.title}</h5>
        <p>{this.props.content}</p>
      </div>
    );
  }
}

TextSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default TextSection;



// WEBPACK FOOTER //
// ./src/components/TextSection/index.js